<template>
  <v-row class="my-0 py-0">
    <!-- Loaders -->
    <v-col
      v-show="loading"
      v-for="(field, inx) in [1, 2, 3, 4, 5, 6]"
      :key="`loading-${inx}`"
      cols="12"
      sm="6"
    >
      <v-skeleton-loader type="text" tile></v-skeleton-loader>
    </v-col>

    <!-- Campos -->
    <v-col
      v-for="(field, inx) in showFormula"
      :key="`${field.name}-${inx}`"
      cols="12"
      md="6"
      lg="3"
    >
      <!-- Campos de medida -->
      <metrics
        v-if="field.type === 'Measure' && measure !== undefined"
        color="secondary"
        :default-measure="defaultMeasure"
        :dimensions="dimensions"
        :disabled="readonly"
        :inx="inx"
        :label="$tc(field.label.toLowerCase(), 1)"
        :measure="measure"
        :name="field.name"
        :readonly="readonly"
        :rounded="rounded"
        :value="field.value"
        @changedimensions="$emit('changedimensions', $event)"
        @input="changeFormula()"
        v-model="field.value"
      />

      <!-- Campos de tiempo -->
      <ValidationProvider
        v-else-if="
          ['hours', 'minutes'].includes(field.label.toLowerCase()) ||
          ['hours', 'minutes'].includes(
            $t(field.label.toLowerCase()).toLowerCase()
          )
        "
        :vid="`time-${inx}`"
        :name="$tc(field.label.toLowerCase(), 1)"
        rules="required|min_value:0"
        v-slot="{ errors }"
      >
        <v-text-field
          outlined
          type="number"
          color="secondary"
          :disabled="readonly"
          :error-messages="errors[0]"
          :label="$tc(field.label.toLowerCase(), 1)"
          @input="changeFormula()"
          v-model="field.value"
        />
      </ValidationProvider>

      <!-- Price -->
      <ValidationProvider
        v-else-if="
          field.type === 'Price' ||
          field.type === 'Cost' ||
          ['price', 'cost', 'precio', 'costo'].includes(
            field.label.toLowerCase()
          )
        "
        :vid="`price-${inx}`"
        :name="$tc('price', 1)"
        rules="required|double:2|min_value:0"
        v-slot="{ errors }"
      >
        <i-money
          v-if="canViewPrice"
          color="secondary"
          :disabled="readonly"
          :error-messages="errors[0]"
          :label="$tc(field.label.toLowerCase(), 1)"
          :name="'number-' + inx"
          @input="changeFormula()"
          v-model="field.value"
        />
      </ValidationProvider>
    </v-col>

    <!-- Subtotal -->
    <v-col
      v-if="showResult"
      class="global-formula--alert-col subtitle-2"
      cols="12"
      sm="6"
      lg="3"
    >
      <v-alert
        color="primary"
        outlined
        type="info"
        @click="showTotalDialog = !showTotalDialog"
      >
        <i-money :value="total * qty" mode="text" :label="$t('subtotal')" />
      </v-alert>
      <v-alert
        class="global-formula--alert"
        colored-border
        dense
        dismissible
        elevation="3"
        type="info"
        v-model="showTotalDialog"
      >
        <v-row
          v-for="(field, inx) in showFormula"
          :key="`${field.name}-${inx}`"
          class="my-0"
        >
          <v-col v-if="field.type === 'Price'" class="pt-0">
            <span class="font-weight-bold body-2 mb-0">
              <i-money
                mode="text"
                :label="`(${$tc('price', 0)} =`"
                :value="field.value"
              />
              ) * (
              {{ `${$tc('measure', 2)}` }} =
              {{ Number(total / field.value).toFixed(2) }}
              {{ defaultMeasure }}) * ({{ `${$tc('amount', 2)}` }} = {{ qty }})
            </span>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>

    <!-- Sandbox para probar la fórmula -->
    <v-col
      v-if="showFormulaString"
      cols="12"
      class="font-weight-black primary--text subtitle-2"
    >
      <v-alert type="success" outlined color="primary">
        <p class="mb-2">{{ `${$t('formula')}: ${totalString}` }}</p>
        <p class="mb-0">
          <i-money :value="total" mode="text" :label="`${$t('total')}:`" />
        </p>
      </v-alert>
    </v-col>
  </v-row>
</template>
<script>
import americanSystem from './americanSystem.vue'

export default {
  components: {
    metrics: americanSystem
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    formula: [Number, Object, String],
    readonly: {
      type: Boolean,
      default: false
    },
    showResult: {
      type: Boolean,
      default: false
    },
    showFormulaString: {
      type: Boolean,
      default: false
    },
    price: {
      type: [Number, String],
      default: 0
    },
    cost: {
      type: [Number, String],
      default: 0
    },
    measure: String,
    defaultMeasure: String,
    dimensions: Object,
    rounded: Boolean,
    rootDimensions: {
      type: Object,
      default: () => ({})
    },
    qty: {
      type: [Number, String],
      default: 0
    },
    subOrder: {
      type: Object,
      default: () => ({})
    },
    isExtraCost: {
      type: Boolean,
      default: false
    },
    is_detail: {
      type: Boolean,
      default: false
    },
    canViewPrice: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      showFormula: [],
      total: 0,
      totalString: '',
      showTotalDialog: false,
      dialogChangePrice: false
    }
  },
  methods: {
    async changeFormula() {
      let show_formula = await this.$store.dispatch('formula/calculator', {
        formula:
          typeof this.formula == 'number' ? this.formula : this.formula.formula,
        vars: this.showFormula
      })
      if (show_formula != undefined) {
        this.$emit('input', show_formula.string)
        this.$emit('change', show_formula.total.toFixed(2))
        this.totalString = show_formula.string
        this.total = show_formula.total.toFixed(2)
      }
    },
    async loadFormula(val) {
      this.loading = true
      this.showFormula = await this.$store.dispatch('formula/calculatedVars', {
        formula: typeof val == 'number' ? val : val.formula,
        vars: this.value
      })
      this.showFormula = this.showFormula.map((f) => {
        if (!isNaN(parseFloat(f.value))) {
          f.value = parseFloat(f.value).toFixed(2)
        }
        return f
      })
      let values = Object.keys(this.rootDimensions)
      let root = true
      if (values.length === 0 && this.dimensions !== undefined) {
        values = Object.keys(this.dimensions)
        root = false
      }
      if (this.price > 0 || this.cost > 0 || values.length > 0) {
        this.showFormula.forEach((m, inx) => {
          if (this.is_detail && m.type === 'Price' && m.value <= 0) {
            m.value = Number(this.cost || 0).toFixed(2)
          }
          if (!this.is_detail && m.type === 'Price' && m.value <= 0) {
            m.value = Number(this.price || 0).toFixed(2)
          }
          if (values.indexOf(m.name) !== -1) {
            let valueFormula = 0
            if (root) {
              valueFormula =
                this.rootDimensions[m.name]['defaultValue'] !== undefined
                  ? this.rootDimensions[m.name]['defaultValue']
                  : this.rootDimensions[m.name]['value']
            } else {
              valueFormula =
                this.dimensions[m.name]['defaultValue'] !== undefined
                  ? this.dimensions[m.name]['defaultValue']
                  : this.dimensions[m.name]['value']
            }
            this.$set(this.showFormula, inx, {
              ...this.showFormula[inx],
              ...{
                value: Number(valueFormula).toFixed(2)
              }
            })
            values = values.filter((element) => element !== m.name)
          }
          /*if (m.type === 'Price') {
            this.$set(this.showFormula, inx, {
              ...this.showFormula[inx],
              ...{ value: this.price }
            })
          } else if (m.type === 'Cost') {
            this.$set(this.showFormula, inx, {
              ...this.showFormula[inx],
              ...{ value: this.cost }
            })
          }*/
        })
      }
      this.changeFormula()
      if (this.dimensions !== undefined) {
        let different = JSON.parse(JSON.stringify(this.dimensions))
        values.forEach((element) => {
          delete different[element]
        })
        this.$emit('changedimensions', different)
      }
      this.loading = false
    }
  },
  watch: {
    total: {
      handler(val) {
        this.$emit('update:subOrder', { ...this.subOrder, total: val })
      }
    },
    rootDimensions: {
      immediate: true,
      deep: true,
      handler(val) {
        if (Object.keys(this.showFormula).length > 0 && val !== undefined) {
          let values = Object.keys(val)
          values.forEach((element) => {
            let inx = this.showFormula.findIndex(
              (item) => item.name === element
            )
            if (inx !== -1) {
              this.$set(this.showFormula, inx, {
                ...this.showFormula[inx],
                ...{
                  value: Number(this.rootDimensions[element]['value']).toFixed(
                    2
                  )
                }
              })
            }
          })
        }
      }
    },
    formula: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.loadFormula(val)
      }
    }
  }
}
</script>
<style lang="sass">
.global-formula
  &--alert-col
    color: var(--v-primary-base)
    font-weight: 900
    position: relative
    font-size: 14px
  &--alert
    margin-bottom: 0
    .v-alert__wrapper
      padding-top: 10px
      padding-bottom: 13px
      .v-icon
        align-self: center
</style>
